import React from 'react';
import classNames from 'classnames';
import { ListItem, IListItemProps } from './ListItem';
import './ListBox.less';
import { ListBoxEmptyMessage } from './ListBoxEmptyMessage';

interface IListBoxProps extends React.HTMLProps<{}> {
  items: IListItemProps[];
  onRemove?: (index: number) => void;
  noItemsText?: string;
  onEdit?: (index: number) => void;
  onMoveUp?: (index: number) => void;
  onMoveDown?: (index: number) => void;
  render?: (index: number) => React.ReactNode;
  contentClassName?: string;
  onMouseOver?: (e: React.MouseEvent<HTMLElement>) => void;
  onMouseOut?: (e: React.MouseEvent<HTMLElement>) => void;
  editingIndex?: number;
  droppingIndex?: number;
  movingUpIndex?: number;
  movingDownIndex?: number;
}

const rootClassName = 'dpc-list-box';
const getClasses = (className?: string) => classNames(rootClassName, className);
const getContentClasses = (contentClassName?: string) => classNames(`${rootClassName}__contents`, contentClassName);

/**
 * List box (used in the editors like ArrayEditor, DataDef Editor
 * Copyright (c) 2019 Decisions All Rights Reserved
 */
export function ListBox({
  className,
  contentClassName,
  items,
  noItemsText,
  onEdit,
  onMouseOut,
  onMouseOver,
  onMoveDown,
  onMoveUp,
  onRemove,
  render,
  ...busyIndexProps
}: IListBoxProps) {
  return (
    <div className={getClasses(className)} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
      {!!items.length && (
        <ul className={getContentClasses(contentClassName)}>
          {items.map((item, i) => (
            <ListItem
              {...busyIndexProps}
              key={`${item.label}-${i}`}
              label={item.label}
              onRemove={item.onRemove || onRemove}
              onEdit={item.onEdit || onEdit}
              index={item.index}
              onMoveUp={onMoveUp}
              onMoveDown={onMoveDown}
              render={render}
            />
          ))}
        </ul>
      )}
      <ListBoxEmptyMessage text={noItemsText} list={items} />
    </div>
  );
}
